import React from 'react';
import { Grid, Typography, Rating } from '@mui/material';

const BookingHeader = ({ name, rating, layout = 'normal' }) => {
  const isDoneDetail = layout === 'doneDetail';

  return (
    <Grid
      container
      alignItems="center"
      wrap="wrap"
      sx={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 1,
        my: '5px',
      }}
    >
      <Typography
        sx={{
          color: '#000',
          fontWeight: 600,
          fontSize: isDoneDetail
            ? { xs: '14px', sm: '16px' }
            : { xs: '16px', sm: '18px' },
          lineHeight: 1.2,
          flex: 1,
          wordBreak: 'break-word',
        }}
      >
        {name}
      </Typography>
      <Rating
        value={Number.parseInt(rating, 10)}
        max={5}
        readOnly
        sx={{
          flexShrink: 0,
          fontSize: isDoneDetail
            ? { xs: '14px', sm: '16px' }
            : { xs: '16px', sm: '18px' },
        }}
      />
    </Grid>
  );
};

export default BookingHeader;
